import styled from 'styled-components'

import { COLOURS, BREAKPOINTS } from 'resources'
import { redemptionSuccessHeaderScribble } from 'resources/images'

export const RedeemSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLOURS.black};
  background-image: url(${redemptionSuccessHeaderScribble});
  background-size: auto 200%;
  background-repeat: no-repeat;
  background-position: 100% 0%;

  @media (min-width: ${BREAKPOINTS.lg}) {
    min-height: 290px;
  }
  @media (min-width: ${BREAKPOINTS.xl}) {
    min-height: 330px;
  }
`

export const Content = styled.div`
  margin: auto 0 0;
`

export const TitleButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${BREAKPOINTS.lg}) {
    flex-direction: row;
  }
`

export const RedeemSuccessTitle = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 46px;
  line-height: 1;
  color: ${COLOURS.white};
  text-align: left;

  @media (min-width: ${BREAKPOINTS.lg}) {
    font-size: 90px;
  }
`
